import React from "react";

import { Status } from "../../enums";
import { TRecordAny } from "../../global.types";

export interface IBaseAlertProps {
    status: Status;
    title?: React.ReactNode;
    subTitle?: React.ReactNode | React.ReactNode[];
    useFade?: boolean;
    action?: AlertAction;
    detailData?: TRecordAny;
}

export enum AlertPosition {
    // rendered as is
    Default = "Default",
    // absolutely positioned in the bottom center
    CenteredBottom = "CenteredBottom",
}

export interface IAlertProps extends IBaseAlertProps {
    /** Element title shown on hover. Use if subTitle isn't string.
     * Otherwise, title is built from subTitle/s automatically. */
    hoverTitle?: string;
    /** Renders with width 100% instead of max-content */
    isFullWidth?: boolean;
    /** Renders without smiley, with smaller padding and font */
    isSmall?: boolean;
    /** Renders both title and subtitle on one line */
    isOneLiner?: boolean;
    /** Adds margin between alert and the following content,
     * that should always be present according to specification */
    shouldAddBottomMargin?: boolean;
    position?: AlertPosition;
    /** Use inverse styled-components theme */
    isInverseTheme?: boolean;
    onClose?: () => void;
    onFadeEnd?: () => void;
    className?: string;
    style?: React.CSSProperties;
    hideSubtitleDiv?: boolean;
    testId?: string;
}

export enum AlertAction {
    // no action by default
    None = "None",
    // adds close button which triggers onClose event
    Close = "Action",
    // adds expand/collapse functionality
    Expand = "Expand"
}

export enum AlertPadding {
    S = "S",
    M = "M",
    L = "L"
}